import React, { useState, useEffect, useCallback } from "react";
import "../styles/status.css";
import { NavLink, Outlet, useParams } from "react-router-dom";
import axios from "axios";
import { Spin } from "antd";

const Status = () => {
  const [contactDetails, setContactDetails] = useState({});
  const [loading, setLoading] = useState(true);

  const { contactId } = useParams();

  // =====================================================
  // FETCH CONTACT DETAILS
  // =====================================================

  useEffect(() => {
    const fetchContactDetails = async () => {
      try {
        setLoading(true);

        const response = await axios.get(
          `/api/contact/getcontact/${contactId}`,
        );

        console.log("Initial contact details:", response.data);

        setContactDetails(response.data || {});
      } catch (error) {
        console.error("Error fetching contact details:", error);
      } finally {
        setLoading(false);
      }
    };

    if (contactId) {
      fetchContactDetails();
    }
  }, [contactId]);

  // =====================================================
  // UPDATE CONTACT FROM MESSAGE STATUS
  //
  // MessageStatus se latest updatedContact yahan aayega.
  // Isse Leads section immediately update hoga.
  // =====================================================

  const updateContactDetails = useCallback((updatedContact) => {
    if (!updatedContact) {
      return;
    }

    console.log("Updating parent contact:", updatedContact);

    setContactDetails((previousContact) => ({
      ...previousContact,
      ...updatedContact,
    }));
  }, []);

  // =====================================================
  // UI
  // =====================================================

  return (
    <div className="page-content w-100">
      <div className="container">
        {/* =================================================
            PAGE TITLE
            ================================================= */}

        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 py-3">{contactDetails.name}</h4>
            </div>
          </div>
        </div>

        {/* =================================================
            MAIN
            ================================================= */}

        <div className="row">
          <div className="col-xxl-12">
            <div className="status_main">
              {/* =================================================
                  LEFT PROFILE SECTION
                  ================================================= */}

              <div className="status_submain">
                <div className="card status_profile">
                  <div className="card-body">
                    {/* ===========================================
                        PRIMARY CONTACT
                        =========================================== */}

                    <h5>Primary Contact</h5>

                    {loading ? (
                      <div className="loading-spinner">
                        <Spin size="large" />
                      </div>
                    ) : (
                      <div
                        style={{
                          color: "#979797",
                        }}
                      >
                        {/* NAME */}

                        <div className="user_details">
                          <span>
                            <i className="ri-user-line"></i>
                          </span>

                          <p>Name: {contactDetails.name}</p>
                        </div>

                        {/* EMAIL */}

                        <div className="user_details">
                          <span>
                            <i className="ri-mail-line"></i>
                          </span>

                          <p>Email: {contactDetails.email}</p>
                        </div>

                        {/* MOBILE */}

                        <div className="user_details mb-4">
                          <span>
                            <i className="ri-phone-line"></i>
                          </span>

                          <p>Mobile: {contactDetails.mobile}</p>
                        </div>
                      </div>
                    )}

                    {/* =================================================
                        LEADS
                        SAME PLACE AS YOUR EXISTING CODE
                        ================================================= */}

                    <h5>Leads</h5>

                    <div
                      style={{
                        color: "#979797",
                      }}
                      className="mb-4"
                    >
                      {Array.isArray(contactDetails.leadscore) &&
                        contactDetails.leadscore.map((score, index) => (
                          <div className="user_details" key={index}>
                            {/* READ */}

                            {score.read !== undefined && (
                              <p className="read-score">Read: {score.read}</p>
                            )}

                            {/* DELIVERED */}

                            {score.delivered !== undefined && (
                              <p className="delivered-score">
                                Delivered: {score.delivered}
                              </p>
                            )}

                            {/* FAILED */}

                            {score.failed !== undefined && (
                              <p className="failed-score">
                                Failed: {score.failed}
                              </p>
                            )}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* =================================================
                  RIGHT STATUS SECTION
                  ================================================= */}

              <div className="card status_table">
                {/* =================================================
                    TABS
                    ================================================= */}

                <div className="card-header">
                  <ul className="nav nav-tabs card-header-tabs">
                    {/* TIMELINE */}

                    <li className="nav-item">
                      <NavLink
                        to={`/dashboard/status/${contactId}/timeline`}
                        className="nav-link"
                      >
                        Timeline
                      </NavLink>
                    </li>

                    {/* NOTES */}

                    <li className="nav-item">
                      <NavLink
                        to={`/dashboard/status/${contactId}/notes`}
                        className="nav-link"
                      >
                        Notes
                      </NavLink>
                    </li>

                    {/* COURSES */}

                    <li className="nav-item">
                      <NavLink
                        to={`/dashboard/status/${contactId}/courses`}
                        className="nav-link"
                      >
                        Courses
                      </NavLink>
                    </li>

                    {/* PERSONAL INFORMATION */}

                    <li className="nav-item">
                      <NavLink
                        to={`/dashboard/status/${contactId}/personalinformation`}
                        className="nav-link"
                      >
                        Personal Information
                      </NavLink>
                    </li>

                    {/* MESSAGE STATUS */}

                    <li className="nav-item">
                      <NavLink
                        to={`/dashboard/status/${contactId}/messagestatus`}
                        className="nav-link"
                      >
                        Message Status
                      </NavLink>
                    </li>
                  </ul>
                </div>

                {/* =================================================
                    CHILD COMPONENT
                    ================================================= */}

                <div className="card-body">
                  <Outlet
                    context={{
                      updateContactDetails,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Status;
